import { useCallback, useState } from 'react'

const STORAGE_PREFIX = 'cai-package-announced:'

function wasAnnounced(packageId: string): boolean {
  try {
    return window.localStorage.getItem(STORAGE_PREFIX + packageId) !== null
  } catch {
    return false
  }
}

/** Open the first time this browser lands on a package; a replaced package is a new one, so it announces again. */
export function usePackageAnnouncement(packageId: string | undefined) {
  const [dismissedId, setDismissedId] = useState<string>()
  const isOpen = !!packageId && dismissedId !== packageId && !wasAnnounced(packageId)

  const dismiss = useCallback(() => {
    if (!packageId) return
    try {
      window.localStorage.setItem(STORAGE_PREFIX + packageId, new Date().toISOString())
    } catch {
      // Blocked storage just means it shows again next visit.
    }
    setDismissedId(packageId)
  }, [packageId])

  return { isOpen, dismiss }
}
